module.exports = __webpack_public_path__ + "img/2x.d904750.jpg";